import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { CouponService } from '@fitness-force/api';
import { CouponType } from '@fitness-force/enum';
import type {
  Client,
  CouponByMasterId,
  CouponEligibleClient,
  EligibleClient,
  OfferMaster,
} from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TENANTS_INFO } from '@fitness-force/state';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { BehaviorSubject, Observable } from 'rxjs';
import { CouponEligibleClientsComponent } from '../coupon-eligible-clients/coupon-eligible-clients.component';

@Component({
  selector: 'add-coupon-to-client',
  templateUrl: './add-coupon-to-client.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DialogModule,
    ScrollPanelModule,
    ButtonModule,
    CouponEligibleClientsComponent,
    TranslateModule,
    AsyncPipe,
  ],
})
export class AddCouponToClientComponent implements OnInit {
  private coupnService = inject(CouponService);
  private store = inject(Store);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  tenantId = 0;
  couponMasterId = 0;
  couponMaster: OfferMaster;
  addClientsModal = new BehaviorSubject(false);
  selectedClients = new BehaviorSubject<CouponEligibleClient[]>([]);

  ngOnInit(): void {
    this.store.select(TENANTS_INFO).subscribe((tenant) => {
      this.tenantId = tenant.selected_tenant.id;
    });
  }

  GetClients(couponMaster: OfferMaster) {
    this.couponMaster = couponMaster;
    this.couponMasterId = couponMaster.id;
    this.addClientsModal.next(true);
    // this.coupnService.getEligibleClients(this.tenantId,couponMaster.id).subscribe({
    //   next: (response: any) => {
    //     this.eligibleClients = response.items as CouponEligibleClient[];
    //     this.selectedClients.next(this.eligibleClients);
    //     this.addClientsModal.next(true);
    //   },
    //   error: (error: any) => {
    //   },
    // });
  }

  closeEvent(event: any) {
    this.addClientsModal.next(false);
    this.selectedClients.next(event.selectedClients);
  }
}
